import React, { memo } from 'react';
import styled from '@emotion/styled';
import { Column, ColumnHeader } from './Column';
import { StatusLabel } from '../../../../shared/status/ui';
import { IFlightPublicStatus } from '../../../../shared/status/domain/models/IFlightPublicStatus';

interface IStatusColumnProps {
	status: IFlightPublicStatus;
	role?: 'columnheader' | 'cell';
}

export const StyledStatusColumn = styled(
	({ role = 'columnheader', ...props }) =>
		role === 'columnheader' ? (
			<ColumnHeader {...props} />
		) : (
			<Column {...props} />
		),
)`
	max-width: 120px;

	@media (max-width: 480px) {
		display: none;
	}
`;

export const StatusColumn = memo(({ status, role }: IStatusColumnProps) => (
	<StyledStatusColumn role={role}>
		<StatusLabel status={status} />
	</StyledStatusColumn>
));
